import { c as _c } from "react/compiler-runtime";
import useSWR from "swr";
import type { ActiveIncident, ListForReceiverResponse, RecentlyResolvedIncident } from "@/client/incident";
import { incidentApi } from "@/client/incident";
const POLLING_INTERVAL_MS = 30_000;
const EMPTY_ACTIVE: ActiveIncident[] = [];
const EMPTY_RESOLVED: RecentlyResolvedIncident[] = [];
type UseIncidentPollingResult = {
  active: ActiveIncident[];
  recentlyResolved: RecentlyResolvedIncident[];
};

/**
 * AssessmentIncident の User API を 30 秒間隔でポーリングする。
 *
 * - 通信失敗時はリトライせず、次回のポーリングに委ねる（業務系の通信に影響させない方針）
 * - 401 は fetchClient 側で 1 回 refresh、それでも失敗した場合は `/auth` へ強制遷移される
 */
export const useIncidentPolling = () => {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["incident", "listForReceiver"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      refreshInterval: POLLING_INTERVAL_MS,
      shouldRetryOnError: false
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data
  } = useSWR(t0, _temp, t1);
  const t2 = data?.active ?? EMPTY_ACTIVE;
  const t3 = data?.recentlyResolved ?? EMPTY_RESOLVED;
  let t4;
  if ($[2] !== t2 || $[3] !== t3) {
    t4 = {
      active: t2,
      recentlyResolved: t3
    };
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
function _temp() {
  return incidentApi.user.listForReceiver();
}